/*
 * @Name 商旅酒店订单相关API定义
 */
const host = 'eventsgo/media/'

/** 查询巴展id */
export const GET_BRAZIL_EXHI_ID = host + 'services/eventsgo/hotel/company/businessOrder/judgmentBrazilExhiID'
// 导出BN订单
export const EXPORT_TRAVEL_ORDER_BN = host + 'services/eventsgo/hotel/company/businessOrder/exportBusinessHotelOrderBN'
// 导出商旅订单
export const EXPORT_TRAVEL_ORDER = host + 'services/eventsgo/hotel/company/businessOrder/exportBusinessHotelOrder'

// 查询展会下的全部商旅订单列表
export const FIND_ALL_BUSINESS_ORDER_PAGE_LIST = host + 'services/eventsgo/hotel/business/hotelService/findAllBusinessOrderPageList'

// 商旅酒店订单列表查询【包含 预订订单与排队订单，入参不一样查询结果不一样】 post
export const FIND_BUSINESS_ORDER_PAGE_LIST = host + 'services/eventsgo/hotel/business/hotelService/findBusinessOrderPageList'

// 商旅酒店订单查询预订房型信息（排队）
export const FIND_BUSINESS_ORDER_HOTEL_LIST_BY_ID = host + 'services/eventsgo/hotel/business/hotelService/findBusinessOrderHotelListById'

// 商旅酒店订单查询预订房型信息（预订）
export const FIND_ORDER_HOTEL_DETAIL_INFO = host + 'services/eventsgo/hotel/company/businessOrder/findOrderHotelDetailInfo'

// 查询订单详情(基础信息)
export const FIND_BUSINESS_ORDER_DETAIL = host + 'services/eventsgo/hotel/business/hotelService/findBusinessOrderDetail'

// // 查询导入名单列表
export const FIND_IMPORT_CHECKIN = host + 'services/eventsgo/hotel/business/order/member/pagedList'

// 查询导入名单列表
export const IMPORT_LOCK = host + 'services/eventsgo/hotel/business/order/member/importLock'

// 撤销订单的导入
export const CANCEL_ROOM_STAY_MEMBER = host + 'services/eventsgo/hotel/business/hotelService/cancelRoomStayMember'

// 查询预定订单已经导入及为导入的房间情况
export const ORDRE_CHECKIN_STATISTICS = host + 'services/eventsgo/hotel/business/order/member/statistics'

// 查询商旅酒店预定订单房间入住信息酒店列表数据
export const HOTEL_PAGE_LIST_BY_ORDERID = host + 'services/eventsgo/hotel/business/order/member/findHotelPageListByOrderId'

// 查询商旅酒店预定订单房间入住信息房型列表数据
export const FIND_HOTEL_ROOM_PAGE_LIST = host + 'services/eventsgo/hotel/business/order/member/findHotelRoomPageList'

// // 查询订单下所有地区部的数据
export const FIND_AREA_PAGE_LIST = host + 'services/eventsgo/hotel/business/order/member/findAreaPageList'

// 查询订单下所有地区部的数据
export const FIND_BUSINESS_ORDER_VERSION = host + 'services/eventsgo/hotel/company/businessOrder/findBusinessOrderVersionInfo'

// 查询订单下所有地区部的数据
export const FIND_BUSINESS_ORDER_VERSION_COMPARISION = host + 'services/eventsgo/hotel/company/businessOrder/findBusinessOrderVersionComparison'

// 删除数据
export const DELETE_SINGLE = host + 'services/eventsgo/hotel/business/order/member/delete/single'

// 加锁服务
export const ROOM_STAY_MEMBER_LOCK = host + 'services/eventsgo/hotel/business/order/member/roomStayMemberLock'

// 解锁服务
export const ROOM_STAY_MEMBER_UNLOCK = host + 'services/eventsgo/hotel/business/order/member/roomStayMemberUnLock'

// 查询预定订单使用情况
export const ORDER_ROOM_USE_SITUATION = host + 'services/eventsgo/hotel/business/roomType'

// 商旅订单取消订单
export const CANCEL_BUSINESS_ORDER = host + 'services/eventsgo/hotel/business/hotelService/cancelBusinessOrder'

// 商旅订单取消校验
export const CHECK_BUSINESS_HOTEL_NOSHOW_FEE = host + 'services/eventsgo/hotel/business/businessHotelFeeService/checkBusinessHotelNoShowFee'

// 商旅订单发送通知
export const UPDATE_BUSINESS_ORDER_STUTES = host + 'services/eventsgo/hotel/business/hotelService/updateBusinessOrderStutes'

// 导入名单导出
export const CHECKIN_EXPORT = host + 'services/eventsgo/hotel/business/order/member/export'

// 导入名单导出
export const VALID_EDIT_PARAMS = host + 'services/eventsgo/hotel/business/order/member/validEditParam'

// // 导入名单导出
export const MEMBER = host + 'services/eventsgo/hotel/business/order/member/save'

// 使用情况导出
export const USE_SITUATION_EXPORT = host + 'services/eventsgo/hotel/business/roomType/export'

// 商旅酒店详情查询房型入住信息
export const FIND_BUSINESS_ORDER_MEMBER_DETAIL_BY_ID = host + 'services/eventsgo/hotel/business/hotelService/findBusinessOrderMemberDetailById'

// 商旅酒店订单全量导出
export const EXPORT_FULL_ORDER = host + 'services/eventsgo/hotel/company/businessOrder/exportBusinessAllHotelOrder'

// 查询商旅预订统计数据
export const GET_BUSINESS_ORDER_COUNT = host + 'services/eventsgo/hotel/company/businessOrder/businessOrderCount'

// 商旅预订统计导出
export const EXPORT_BUSINESS_ORDER_COUNT = host + 'services/eventsgo/hotel/company/businessOrder/businessOrderCount/export'

// 商旅订单。根据酒店ID、房型ID，日期范围查询 酒店实际入住量 hotelId roomTypeId beginUseDay endUseDay GET
export const GET_REL_USE_INFO = host + 'services/eventsgo/hotel/business/roomType/relUseInfo/list'

// 商旅订单。 录入与更新实际酒店房型实际入住量 POST
export const BATCH_CREATE_UPDATE = host + 'services/eventsgo/hotel/business/roomType/relUseInfo/batchCreateUpdate'

// 商旅预订统计界面导出客户
export const EXPORT_HOTEL_ALL_STAY_MEMBER = host + 'services/eventsgo/hotel/business/roomType/export/hotelAllStayMember'
